import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteSpecialty } from './DeleteSpecialty';
import { FormSpecialty } from './FormSpecialty';
import { Dialog } from 'primereact/dialog';

export const ModalSpecialty = (props) => {

    const {
        modal, toggle, method, loading,
        name, handleInputChange, validaciones,
        saveCreate, saveUpdate, saveDelete, closeModalSpeciality
    } = props;

    const title =
        method === "create"
            ? "Registrar Especialidad"
            : method === "update"
                ? "Actualizar Especialidad"
                : "Eliminar Especialidad";



    const dialogTheme = method === "delete"
        ? ` seller-dialog seller-dialog seller-danger seller-small-v`
        : "Global-dialog Global-blue Global-small-v ";


    const icon = method === "delete"
        ? <i className="fa fa-trash"></i>
        : <i className="fa fa-stethoscope header-icon"></i>


    return (

        <Dialog
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            {icon}
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {title}

                            </div>
                        </div>
                    </div>
                </div>
            }
            className={` ${dialogTheme}`}
            maskClassName="custom-total-mask"
            //header={title}
            visible={modal}
            onHide={closeModalSpeciality}
            //className={dialogClassName}
            blockScroll={true}
            modal
            closable={true}
            dismissableMask
        >

            {
                method === "create" ?
                    <FormSpecialty
                        button="Crear nuevo especialidad"
                        {...{ toggle, loading, name, handleInputChange, validaciones, methodAction: saveCreate, closeModalSpeciality }}
                    />
                    : (method === "update") ?
                        <FormSpecialty
                            button="Actualizar especialidad"
                            {...{ toggle, loading, name, handleInputChange, validaciones, methodAction: saveUpdate, closeModalSpeciality }}
                        />
                        : <DeleteSpecialty {...{ toggle, loading, name, saveDelete }} />
            }
        </Dialog>
    )
}
